// @noflow
import './styles.css';

import { DeviceSelector, GenericSelector } from '../';
import { injectIntl, intlShape } from 'react-intl';

import classnames from 'classnames';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import * as React from 'react';

const selectorBaseClassname = 'then-consumer__selector';
const separatorBaseClassname = 'then-consumer__separator';
const getModifierClasses = index => {
    const truthMap = {
        [true]: {
            selectorModifier: `${selectorBaseClassname}--pale-grey`,
            separatorModifier: `${separatorBaseClassname}--light-grey`
        },
        [index % 2 === 1]: {
            selectorModifier: `${selectorBaseClassname}--light-grey`,
            separatorModifier: `${separatorBaseClassname}--pale-grey`
        },
        [index === 0]: {
            selectorModifier: `${selectorBaseClassname}--pale-grey`,
            separatorModifier: ''
        }
    };
    return truthMap[true];
};

const propTypes = {
    deviceList: ImmutablePropTypes.list.isRequired,
    deviceType: PropTypes.string.isRequired,
    handleDeviceSelection: PropTypes.func,
    intl: intlShape,
    isDeviceActiveState: PropTypes.bool.isRequired,
    propertiesList: ImmutablePropTypes.listOf(
        ImmutablePropTypes.contains({
            handler: PropTypes.func.isRequired,
            label: PropTypes.object.isRequired,
            optionsList: ImmutablePropTypes.list.isRequired,
            selectedIndex: PropTypes.number.isRequired
        })
    ).isRequired,
    selectedDeviceIndex: PropTypes.number.isRequired
};

const RecipeThenConsumer = ({
    propertiesList,
    deviceList,
    deviceType,
    handleDeviceSelection,
    intl: { formatMessage },
    isDeviceActiveState,
    selectedDeviceIndex
}) => (
    <div className="then-consumer">
        <DeviceSelector
            currentIndex={selectedDeviceIndex}
            deviceType={deviceType}
            handleSelection={handleDeviceSelection}
            isDeviceActiveState={isDeviceActiveState}
            list={deviceList}
        />
        {propertiesList.map((d, index) => {
            const { separatorModifier, selectorModifier } = getModifierClasses(index);
            return (
                <div key={`consumer-${index}`}>
                    <div className={classnames(separatorBaseClassname, separatorModifier)} />
                    <GenericSelector
                        className={selectorModifier}
                        currentIndex={d.get('selectedIndex')}
                        description={formatMessage(d.get('label').toJS())}
                        handleSelection={d.get('handler')}
                        list={d.get('optionsList').map(o => {
                            const label = o.get('label');
                            return typeof label === 'string' ? label : formatMessage(o.get('label').toJS());
                        })}
                    />
                </div>
            );
        })}
    </div>
);

RecipeThenConsumer.propTypes = propTypes;

export default injectIntl(RecipeThenConsumer);



// WEBPACK FOOTER //
// ./src/components/widgets/recipes/then-consumer/index.js